import { render, staticRenderFns } from "./MainLayout.vue?vue&type=template&id=f4bf6154"
import script from "./mainLayout.ts?vue&type=script&lang=ts&external"
export * from "./mainLayout.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports